export const normalizeMeasureLabel = (value: string | null | undefined) =>
  (value ?? "").trim().toLowerCase();
